<template>
  <div id="app">
    <el-config-provider :locale="locale">
      <router-view />
      <!-- 这里是内容 -->
    </el-config-provider>
  </div>
</template>

<script>
import "@/assets/main.css";
import { ElConfigProvider } from 'element-plus'

// 引入中文包
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  setup() {
    const lang = () => {// eslint-disable-line no-unused-vars(如果运行时报错，就加上前面这行注释)
      location.reload()
    }
    let locale = zhCn
    return {
      locale
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/**禁止选中文本 */
*{

  moz-user-select: -moz-none;

  -moz-user-select: none;

  -o-user-select:none;

  -khtml-user-select:none;

  -webkit-user-select:none;

  -ms-user-select:none;

  user-select:none;

}
</style>
